<section class="panel panel-default">
    <div class="panel-heading">Country Capex/Capacity by Stage</div>
    <div class="panel-body">
        <div class="chart-host" *ngIf="ticks.length; else emptyChart">
            <svg class="chart-svg" [attr.viewBox]="'0 0 ' + viewWidth + ' ' + viewHeight" preserveAspectRatio="none">
                <line
                    class="chart-axis"
                    [attr.x1]="chartLeft"
                    [attr.y1]="viewHeight - chartBottom"
                    [attr.x2]="viewWidth - chartRight"
                    [attr.y2]="viewHeight - chartBottom"></line>

                <g *ngFor="let segment of segments">
                    <rect
                        [attr.x]="segment.x"
                        [attr.y]="segment.y"
                        [attr.width]="segment.width"
                        [attr.height]="segment.height"
                        [attr.class]="'chart-segment ' + segment.stageClass + (isSelected(segment.point) ? ' chart-segment-selected' : '')"
                        (click)="selectPoint(segment.point)">
                    </rect>
                    <title>{{ segment.point.startupYear }} · {{ segment.point.stageLabel }} · {{ segment.point.value | number: '1.0-0' }}</title>
                </g>

                <text
                    *ngFor="let tick of ticks"
                    class="chart-tick"
                    [attr.x]="tick.x"
                    [attr.y]="viewHeight - 8"
                    text-anchor="middle">
                    {{ tick.label }}
                </text>
            </svg>
        </div>
        <ng-template #emptyChart>
            <div>No chart data available for this country.</div>
        </ng-template>
    </div>
</section>
